<div class="d-flex flex-column align-items-center gap-32">
  <div class="text-content" #textContainer></div>
  <div class="w-100 d-flex flex-column align-items-center justify-content-center">
    <div class="waveform-container">
      <div class="waveform" #waveform></div>
    </div>
  </div>
</div>
